export const LIFELINE_TABLE_NAME = 'lifeline_dashboard_events';

export const HelpDeskEventName = {
  HELP_NODE_SHOWN: 'HELP_NODE_SHOWN', //Which primary node is being shown
  HELP_NODE_OPENED: 'HELP_NODE_OPENED',
  HELP_NODE_CLOSED: 'HELP_NODE_CLOSED',
  ISSUE_TYPE_FILTER_CHANGE: 'ISSUE_TYPE_FILTER_CHANGE',
  ITEM_NAME_FILTER_CHANGE: 'ITEM_NAME_FILTER_CHANGE',
  COMPLAINT_AMOUNT_INPUT_CHANGE: 'COMPLAINT_AMOUNT_INPUT_CHANGE',
  HELP_DESK_FILTERS_CLEARED: 'HELP_DESK_FILTERS_CLEARED',
  HELP_HOME_BUTTON_CLICKED: 'HELP_HOME_BUTTON_CLICKED', // It shown going to default state of help desk
  HELP_DESK_COLLAPSED: 'HELP_DESK_COLLAPSED',
  HELP_DESK_EXPANDED: 'HELP_DESK_EXPANDED',
  HELP_DESK_OPENED: 'HELP_DESK_OPENED',
  HELP_DESK_CLOSED: 'HELP_DESK_CLOSED',
  HELP_DESK_DRAGGED: 'HELP_DESK_DRAGGED',
  NON_PRIMARY_HELP_NODE_EXPLORED: 'NON_PRIMARY_HELP_NODE_EXPLORED', // Nodes which are not shown on first
};

export const RaiseAnIssueEventName = {
  ISSUE_CLICKED: 'ISSUE_CLICKED',
  UPLOAD_COMPLAINT_MEDIA_CLICKED: 'UPLOAD_COMPLAINT_MEDIA_CLICKED',
  VIEW_UPLOAD_MODAL_CLICKED: 'VIEW_UPLOAD_MODAL_CLICKED',
  REFRESH_MEDIA_CLICKED: 'REFRESH_MEDIA_CLICKED',
  DELETE_COMPLAINT_MEDIA_IN_MODAL: 'DELETE_COMPLAINT_MEDIA_IN_MODAL',
  ISSUE_ITEM_QUANTITY_UPDATED: 'ISSUE_ITEM_QUANTITY_UPDATED',
  ISSUE_ITEM_PICKUP_CLICKED: 'ISSUE_ITEM_PICKUP_CLICKED',
  ISSUE_ITEM_CUSTOM_REFUND_UPDATED: 'ISSUE_ITEM_CUSTOM_REFUND_UPDATED',
  RAISE_AN_ISSUE_NEXT_BTN_CLICKED: 'RAISE_AN_ISSUE_NEXT_BTN_CLICKED',
  ISSUE_ITEM_EDIT_UPLOAD_MEDIA_CLICKED: 'ISSUE_ITEM_EDIT_UPLOAD_MEDIA_CLICKED',
  ISSUE_ITEM_EDIT_DETAILS_CLICKED: 'ISSUE_ITEM_EDIT_DETAILS_CLICKED',
  ISSUE_RESOLUTION_SELECTED: 'ISSUE_RESOLUTION_SELECTED',
  ISSUE_RESOLVE_NOW_BTN_CLICKED: 'ISSUE_RESOLVE_NOW_BTN_CLICKED',
  VERIFY_ADDRESS_BTN_CLICK_EVENT: 'VERIFY_ADDRESS_BTN_CLICK_EVENT',
};

export const IVAEventsName = {
  IVA_APPROVE_REJECT_BTN_CLICKED: 'IVA_APPROVE_REJECT_BTN_CLICKED',
  IVA_REASON_SELECTION: 'IVA_REASON_SELECTION',
  IVA_APPROVAL_CONTINUE_BTN_CLICKED: 'IVA_APPROVAL_CONTINUE_BTN_CLICKED',
  IVA_FINAL_RESOLUTION: 'IVA_FINAL_RESOLUTION',
};

export const ContextPassingEventsName = {
  IVA_CHAT_SUMMARY_BTN_CLICK: 'IVA_CHAT_SUMMARY_BTN_CLICK',
  SMARTPLUG_CHAT_SUMMARY_BTN_CLICK: 'SMARTPLUG_CHAT_SUMMARY_BTN_CLICK',
  IVA_RESOLUTIONS_BTN_CLICK: 'IVA_RESOLUTIONS_BTN_CLICK',
};

export const StoreServiceabilityEventName = {
  FIND_SERVICEABLE_MERCHANTS_CLICK_EVENT:
    'FIND_SERVICEABLE_MERCHANTS_CLICK_EVENT',
  CHECK_STORE_SERVICEABILITY_INPUT_EVENT:
    'CHECK_STORE_SERVICEABILITY_INPUT_EVENT',
  UPDATE_CUSTOMER_LOCATION_EVENT: 'UPDATE_CUSTOMER_LOCATION_EVENT',
};

export const LifelineLoginFeatureEventName = {
  LIFELINE_LOGIN_BTN_CLICK_EVENT: 'LIFELINE_LOGIN_BTN_CLICK_EVENT',
};

export const LifelineLogoutFeatureEventName = {
  LIFELINE_LOGOUT_BTN_CLICK_EVENT: 'LIFELINE_LOGOUT_BTN_CLICK_EVENT',
  LIFELINE_AUTO_LOGOUT_TRIGGER_EVENT: 'LIFELINE_AUTO_LOGOUT_TRIGGER_EVENT',
};

export const HelpDeskFilterEventNameMap = {
  complaint_type: HelpDeskEventName.ISSUE_TYPE_FILTER_CHANGE,
  item_name: HelpDeskEventName.ITEM_NAME_FILTER_CHANGE,
  complaint_amount: HelpDeskEventName.COMPLAINT_AMOUNT_INPUT_CHANGE,
};

export const playGroundModeEventName = {
  PLAYGROUND_MODE_TURN_ON: 'PLAYGROUND_MODE_ON',
  PLAYGROUND_MODE_TURN_OFF: 'PLAYGROUND_MODE_OFF',
};

export const CallEventsName = {
  USER_PRIMARY_NUMBER_CALL_CLICK_EVENT: 'USER_PRIMARY_NUMBER_CALL_CLICK_EVENT',
  USER_ALTERNATIVE_NUMBER_CALL_CLICK_EVENT:
    'USER_ALTERNATIVE_NUMBER_CALL_CLICK_EVENT',
  MERCHANT_CALL_CLICK_EVENT: 'MERCHANT_CALL_CLICK_EVENT',
  VALET_CALL_CLICK_EVENT: 'VALET_CALL_CLICK_EVENT',
  ASSIGNED_RIDER_CALL_CLICK_EVENT: 'ASSIGNED_RIDER_CALL_CLICK_EVENT',
  OFSE_USER_CALL_CLICK_EVENT: 'OFSE_USER_CALL_CLICK_EVENT',
};

export const SubstitutionEventsName = {
  SUBSTITUTION_ITEM_CLICK_EVENT: 'SUBSTITUTION_ITEM_CLICK_EVENT',
};

export const ResoAssistEventsName = {
  RESO_ASSIST_CALL_RESPONSE_DROPDOWN_CLICK_EVENT:
    'RESO_ASSIST_CALL_RESPONSE_DROPDOWN_CLICK_EVENT',
  RESO_ASSIST_PROCEED_BTN_CLICK_EVENT: 'RESO_ASSIST_PROCEED_BTN_CLICK_EVENT',
};

export const AddressViewEventsName = {
  SEE_MAP_CLICK_EVENT: 'SEE_MAP_CLICK_EVENT',
  RECENTLY_USED_ADDRESSES_CLICK_EVENT: 'RECENTLY_USED_ADDRESSES_CLICK_EVENT',
  LOAD_MORE_ADDRESSES_CLICK_EVENT: 'LOAD_MORE_ADDRESSES_CLICK_EVENT',
  UNMASK_ADDRESS_CLICK_EVENT: 'UNMASK_ADDRESS_CLICK_EVENT',
  VIEW_ON_MAP_CLICK_EVENT: 'VIEW_ON_MAP_CLICK_EVENT',
  LAT_LONG_COPY_EVENT: 'LAT_LONG_COPY_EVENT',
  OPEN_GOOGLE_MAPS_CLICK_EVENT: 'OPEN_GOOGLE_MAPS_CLICK_EVENT',
};

export const CopilotEventName = {
  // Panel-level (not tied to a single step)
  COPILOT_BUTTON_CLICKED: 'COPILOT_BUTTON_CLICKED',
  COPILOT_FLOW_DROP_OFF: 'COPILOT_FLOW_DROP_OFF',
  COPILOT_UPLOADED_IMAGE_VIEW_CLICK: 'COPILOT_UPLOADED_IMAGE_VIEW_CLICK',

  // Step 1 - Order & Product Confirmation
  COPILOT_STEP_1_OPENED: 'COPILOT_STEP_1_OPENED',
  COPILOT_STEP_1_PRODUCT_SELECTION_CHANGED:
    'COPILOT_STEP_1_PRODUCT_SELECTION_CHANGED',
  COPILOT_STEP_1_CTA_CLICKED: 'COPILOT_STEP_1_CTA_CLICKED',
  COPILOT_STEP_1_CTA_RESPONSE: 'COPILOT_STEP_1_CTA_RESPONSE',

  // Step 2 - Complaint Identification
  COPILOT_STEP_2_OPENED: 'COPILOT_STEP_2_OPENED',
  COPILOT_STEP_2_COMPLAINT_TYPE_CHANGED:
    'COPILOT_STEP_2_COMPLAINT_TYPE_CHANGED',
  COPILOT_STEP_2_CTA_CLICKED: 'COPILOT_STEP_2_CTA_CLICKED',
  COPILOT_STEP_2_CTA_RESPONSE: 'COPILOT_STEP_2_CTA_RESPONSE',

  // Step 3 - Verification
  COPILOT_STEP_3_OPENED: 'COPILOT_STEP_3_OPENED',
  COPILOT_STEP_3_CHECKLIST_ITEM_TOGGLED:
    'COPILOT_STEP_3_CHECKLIST_ITEM_TOGGLED',
  COPILOT_STEP_3_GRIEVANCE_LEVEL_SELECTED:
    'COPILOT_STEP_3_GRIEVANCE_LEVEL_SELECTED',
  COPILOT_STEP_3_CTA_CLICKED: 'COPILOT_STEP_3_CTA_CLICKED',
  COPILOT_STEP_3_CTA_RESPONSE: 'COPILOT_STEP_3_CTA_RESPONSE',
  COPILOT_STEP_3_CANNOT_VERIFY_RESPONSE_SHOWN:
    'COPILOT_STEP_3_CANNOT_VERIFY_RESPONSE_SHOWN',

  // Step 4 - Resolution
  COPILOT_STEP_4_OPENED: 'COPILOT_STEP_4_OPENED',
  COPILOT_STEP_4_PICKUP_TOGGLED: 'COPILOT_STEP_4_PICKUP_TOGGLED',
  COPILOT_STEP_4_RESOLUTION_TYPE_SELECTED:
    'COPILOT_STEP_4_RESOLUTION_TYPE_SELECTED',
  COPILOT_STEP_4_CTA_CLICKED: 'COPILOT_STEP_4_CTA_CLICKED',
  COPILOT_STEP_4_CTA_RESPONSE: 'COPILOT_STEP_4_CTA_RESPONSE',
  COPILOT_STEP_4_TAGS_ADDED_ON_CLOSE: 'COPILOT_STEP_4_TAGS_ADDED_ON_CLOSE',
};

// "RFO" = Retail Forward Order. Rides the generic server-driven
// get_applicable_reasons -> raise_issue/{reasonId} -> submit flow
// (ActionsView.js / CreditDetails.js / ReportIssue.js) - reason id 208 is
// the "Cancel & Create RFO" path, so every step-level event here is gated
// on that reason id rather than a dedicated RFO-only screen.
export const RFO_CACR_REASON_ID = 208;

export const RfoEventName = {
  RFO_APPLICABLE_REASONS_FETCHED: 'RFO_APPLICABLE_REASONS_FETCHED',
  RFO_CACR_OPTION_CLICKED: 'RFO_CACR_OPTION_CLICKED',
  RFO_ISSUE_INFO_RESPONSE: 'RFO_ISSUE_INFO_RESPONSE',
  RFO_CANCELLATION_REASON_SELECTED: 'RFO_CANCELLATION_REASON_SELECTED',
  RFO_EVALUATE_RESPONSE: 'RFO_EVALUATE_RESPONSE',
  RFO_SUBMIT_CTA_CLICKED: 'RFO_SUBMIT_CTA_CLICKED',
};

export const EventName = {
  POP_UP_OPENEND: 'POP_UP_OPENEND',
  POP_UP_CLOSED: 'POP_UP_CLOSED',
  LOGIN_FAILURE: 'LOGIN_FAILURE',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  SEARCH_EVENT: 'SEARCH_EVENT',
  SEARCH_FILTER_CHANGE: 'SEARCH_FILTER_CHANGE',
  LOAD_MORE_ORDERS: 'LOAD_MORE_ORDERS',
  DOWNLOAD_INVOICE: 'DOWNLOAD_INVOICE',
  ...LifelineLoginFeatureEventName,
  ...LifelineLogoutFeatureEventName,
  ...StoreServiceabilityEventName,
  ...playGroundModeEventName,
  ...HelpDeskEventName,
  ...RaiseAnIssueEventName,
  ...IVAEventsName,
  ...ContextPassingEventsName,
  ...CallEventsName,
  ...SubstitutionEventsName,
  ...ResoAssistEventsName,
  ...AddressViewEventsName,
  ...CopilotEventName,
  ...RfoEventName,
};

export const FeatureName = {
  SEARCH: 'SEARCH',
  ANNOUNCEMENT: 'ANNOUNCEMENT',
  ALERTS: 'ALERTS',
  PLAYGROUND_MODE: 'PLAYGROUND_MODE',
  TOTP_GENERATE_QR: 'TOTP_GENERATE_QR',
  VIEW_ISSUES: 'VIEW_ISSUES',
  TRANSACTIONS: 'TRANSACTIONS',
  COMMENTS: 'COMMENTS',
  CALL_LOGS: 'CALL_LOGS',
  HELP: 'HELP',
  KEBAB_MENU: 'KEBAB_MENU',
  ITEM_AND_BILLING: 'ITEM_AND_BILLING',
  RAISE_AN_ISSUE: 'RAISE_AN_ISSUE',
  LIFELINE_LOGIN_FEATURE: 'LIFELINE_LOGIN_FEATURE',
  LIFELINE_LOGOUT_FEATURE: 'LIFELINE_LOGOUT_FEATURE',
  STORE_SERVICEABILITY_FEATURE: 'STORE_SERVICEABILITY_FEATURE',
  CONTEXT_PASSING_FEATURE: 'CONTEXT_PASSING_FEATURE',
  CALLING_FEATURE: 'CALLING_FEATURE',
  SUBSTITUTION_FEATURE: 'SUBSTITUTION_FEATURE',
  RESO_ASSIST_FEATURE: 'RESO_ASSIST_FEATURE',
  ADDRESS_VIEW_FEATURE: 'ADDRESS_VIEW_FEATURE',
  COPILOT_FEATURE: 'COPILOT_FEATURE',
  RFO_FEATURE: 'RFO_FEATURE',
};

export const EventType = {
  PAGE_VISIT: 'PAGE_VISIT',
  SHOWN: 'SHOWN',
  CLICK: 'CLICK',
  ERROR: 'ERROR',
  COPY: 'COPY',
};

export const DashboardMode = {
  NORMAL_LIFLINE: 'NORMAL_LIFLINE',
  LIFELINE_IVA: 'LIFELINE_IVA',
  LIFELINE_SMARTPLUG: 'LIFELINE_SMARTPLUG',
  ADMIN_DASHBAORD: 'ADMIN_DASHBAORD',
  BULK_DASHBAORD: 'BULK_DASHBAORD',
  PERMISSION_DASHBOARD: 'PERMISSION_DASHBOARD',
};

export const pathnameDashboardMap = {
  '/lifeline': DashboardMode.NORMAL_LIFLINE,
  '/lifeline/smartplugs/o2-india-lifeline': DashboardMode.LIFELINE_SMARTPLUG,
  '/lifeline/smartplugs/handover': DashboardMode.LIFELINE_IVA,
};

export const MetricsForJumboEvent = {
  event_name: 'event_name',
  event_type: 'event_type',
  feature_name: 'feature_name',
  feature_meta: 'feature_meta',
  browser: 'browser',
  user_role: 'user_role',
  user_login_flow: 'user_login_flow',
  dashboard_mode: 'dashboard_mode',
  customer_id: 'customer_id',
  order_id: 'order_id',
  cart_id: 'cart_id',
};

export const EventFeatureMap = {
  // Core Lifeline events
  [EventName.LIFELINE_LOGIN_BTN_CLICK_EVENT]:
    FeatureName.LIFELINE_LOGIN_FEATURE,

  [EventName.LIFELINE_LOGOUT_BTN_CLICK_EVENT]:
    FeatureName.LIFELINE_LOGOUT_FEATURE,

  [EventName.LIFELINE_AUTO_LOGOUT_TRIGGER_EVENT]:
    FeatureName.LIFELINE_LOGOUT_FEATURE,

  // for Raise An Issue events
  [RaiseAnIssueEventName.ISSUE_CLICKED]: FeatureName.RAISE_AN_ISSUE,
  [RaiseAnIssueEventName.UPLOAD_COMPLAINT_MEDIA_CLICKED]:
    FeatureName.RAISE_AN_ISSUE,
  [RaiseAnIssueEventName.VIEW_UPLOAD_MODAL_CLICKED]: FeatureName.RAISE_AN_ISSUE,
  [RaiseAnIssueEventName.REFRESH_MEDIA_CLICKED]: FeatureName.RAISE_AN_ISSUE,
  [RaiseAnIssueEventName.DELETE_COMPLAINT_MEDIA_IN_MODAL]:
    FeatureName.RAISE_AN_ISSUE,
  [RaiseAnIssueEventName.ISSUE_ITEM_QUANTITY_UPDATED]:
    FeatureName.RAISE_AN_ISSUE,
  [RaiseAnIssueEventName.ISSUE_ITEM_PICKUP_CLICKED]: FeatureName.RAISE_AN_ISSUE,
  [RaiseAnIssueEventName.ISSUE_ITEM_CUSTOM_REFUND_UPDATED]:
    FeatureName.RAISE_AN_ISSUE,
  [RaiseAnIssueEventName.RAISE_AN_ISSUE_NEXT_BTN_CLICKED]:
    FeatureName.RAISE_AN_ISSUE,
  [RaiseAnIssueEventName.ISSUE_ITEM_EDIT_UPLOAD_MEDIA_CLICKED]:
    FeatureName.RAISE_AN_ISSUE,
  [RaiseAnIssueEventName.ISSUE_ITEM_EDIT_DETAILS_CLICKED]:
    FeatureName.RAISE_AN_ISSUE,
  [RaiseAnIssueEventName.ISSUE_RESOLUTION_SELECTED]: FeatureName.RAISE_AN_ISSUE,
  [RaiseAnIssueEventName.ISSUE_RESOLVE_NOW_BTN_CLICKED]:
    FeatureName.RAISE_AN_ISSUE,
  [EventName.VERIFY_ADDRESS_BTN_CLICK_EVENT]: FeatureName.RAISE_AN_ISSUE,

  // for IVA events
  [IVAEventsName.IVA_APPROVE_REJECT_BTN_CLICKED]: FeatureName.RAISE_AN_ISSUE,
  [IVAEventsName.IVA_REASON_SELECTION]: FeatureName.RAISE_AN_ISSUE,
  [IVAEventsName.IVA_APPROVAL_CONTINUE_BTN_CLICKED]: FeatureName.RAISE_AN_ISSUE,
  [IVAEventsName.IVA_FINAL_RESOLUTION]: FeatureName.RAISE_AN_ISSUE,

  // Store Serviceability events
  [StoreServiceabilityEventName.FIND_SERVICEABLE_MERCHANTS_CLICK_EVENT]:
    FeatureName.STORE_SERVICEABILITY_FEATURE,
  [EventName.CHECK_STORE_SERVICEABILITY_INPUT_EVENT]:
    FeatureName.STORE_SERVICEABILITY_FEATURE,
  [StoreServiceabilityEventName.UPDATE_CUSTOMER_LOCATION_EVENT]:
    FeatureName.STORE_SERVICEABILITY_FEATURE,

  // Context Passing events
  [ContextPassingEventsName.IVA_CHAT_SUMMARY_BTN_CLICK]:
    FeatureName.CONTEXT_PASSING_FEATURE,
  [ContextPassingEventsName.SMARTPLUG_CHAT_SUMMARY_BTN_CLICK]:
    FeatureName.CONTEXT_PASSING_FEATURE,
  [ContextPassingEventsName.IVA_RESOLUTIONS_BTN_CLICK]:
    FeatureName.CONTEXT_PASSING_FEATURE,

  // Call Logs events
  [CallEventsName.USER_PRIMARY_NUMBER_CALL_CLICK_EVENT]:
    FeatureName.CALLING_FEATURE,
  [CallEventsName.USER_ALTERNATIVE_NUMBER_CALL_CLICK_EVENT]:
    FeatureName.CALLING_FEATURE,
  [CallEventsName.MERCHANT_CALL_CLICK_EVENT]: FeatureName.CALLING_FEATURE,
  [CallEventsName.VALET_CALL_CLICK_EVENT]: FeatureName.CALLING_FEATURE,
  [CallEventsName.ASSIGNED_RIDER_CALL_CLICK_EVENT]: FeatureName.CALLING_FEATURE,
  [CallEventsName.OFSE_USER_CALL_CLICK_EVENT]: FeatureName.CALLING_FEATURE,

  //Substitution flow events
  [SubstitutionEventsName.SUBSTITUTION_ITEM_CLICK_EVENT]:
    FeatureName.SUBSTITUTION_FEATURE,

  // Reso Assist events
  [ResoAssistEventsName.RESO_ASSIST_CALL_RESPONSE_DROPDOWN_CLICK_EVENT]:
    FeatureName.RESO_ASSIST_FEATURE,
  [ResoAssistEventsName.RESO_ASSIST_PROCEED_BTN_CLICK_EVENT]:
    FeatureName.RESO_ASSIST_FEATURE,

  // Address View events
  [AddressViewEventsName.SEE_MAP_CLICK_EVENT]: FeatureName.ADDRESS_VIEW_FEATURE,
  [AddressViewEventsName.RECENTLY_USED_ADDRESSES_CLICK_EVENT]:
    FeatureName.ADDRESS_VIEW_FEATURE,
  [AddressViewEventsName.LOAD_MORE_ADDRESSES_CLICK_EVENT]:
    FeatureName.ADDRESS_VIEW_FEATURE,
  [AddressViewEventsName.UNMASK_ADDRESS_CLICK_EVENT]:
    FeatureName.ADDRESS_VIEW_FEATURE,
  [AddressViewEventsName.VIEW_ON_MAP_CLICK_EVENT]:
    FeatureName.ADDRESS_VIEW_FEATURE,
  [AddressViewEventsName.LAT_LONG_COPY_EVENT]: FeatureName.ADDRESS_VIEW_FEATURE,
  [AddressViewEventsName.OPEN_GOOGLE_MAPS_CLICK_EVENT]:
    FeatureName.ADDRESS_VIEW_FEATURE,

  // Copilot flow events - every CopilotEventName entry maps to the one
  // Copilot feature, so this is generated rather than listed by hand.
  ...Object.fromEntries(
    Object.values(CopilotEventName).map((eventName) => [
      eventName,
      FeatureName.COPILOT_FEATURE,
    ]),
  ),

  // RFO flow events - same generated-mapping pattern as Copilot above.
  ...Object.fromEntries(
    Object.values(RfoEventName).map((eventName) => [
      eventName,
      FeatureName.RFO_FEATURE,
    ]),
  ),
};
